import { IMakeRequest } from '../helpers/network_helper';
import { IUser } from '../models/user';

export const getUserDataApi = (makeRequest: IMakeRequest, host: string) => {
  const headers: [string, string][] = [
    ['Content-Type', 'application/json'],
  ];

  return makeRequest({
    method: 'GET',
    uri: {
      host,
      path: '/cian-api/site/v1/get-user-data-by-request/',
    },
    headers,
  }).then((res: {data: {user: IUser}}) => res.data.user);
};
